const ENTITY_COLLECTIONS = Object.freeze({
  event: 'events',
  events: 'events',
  resource: 'resources',
  resources: 'resources',
  request: 'requests',
  requests: 'requests',
  response: 'responses',
  responses: 'responses',
  command: 'commands',
  commands: 'commands',
  acknowledgement: 'acknowledgements',
  acknowledgements: 'acknowledgements',
  type: 'types',
  types: 'types',
  auxiliary: 'auxiliaries',
  auxiliaries: 'auxiliaries',
  complexDataType: 'complexDataTypes',
});

export function getSchemaCollectionKey(type) {
  return ENTITY_COLLECTIONS[type] || null;
}

export function getSchemaItems(groupData, type) {
  const collectionKey = getSchemaCollectionKey(type);
  const items = collectionKey ? groupData?.[collectionKey] : null;
  return Array.isArray(items) ? items : [];
}

export function getSchemaEndpointSegment(type) {
  if (type === 'complexDataType') return 'complexdatatypes';
  return getSchemaCollectionKey(type);
}
